/**
 * 창업 상황 폼의 입력 보정과 사전 검증.
 *
 * 서버 `LeadUpdateRequest`는 연도 2000~2100, 월 1~12, 경력 연수 0 이상만 받고 하나라도 어긋나면
 * 요청 전체를 400으로 거절한다. 그러면 같은 폼의 공간 상태·예산·가족 동의도 저장되지 않아 적격성
 * 판정 버튼이 계속 막힌다 (2026-09-07 QA, "26" 입력). 화면에서 먼저 걸러 무엇이 잘못됐는지 말한다.
 */

export const OPEN_YEAR_MIN = 2000
export const OPEN_YEAR_MAX = 2100

/** "26"처럼 두 자리로 적은 연도는 2000년대로 읽는다. 그 외는 그대로 둔다. */
export function normalizeOpenYear(raw: string): string {
  const trimmed = raw.trim()
  if (!/^\d{1,2}$/.test(trimmed)) return trimmed
  return String(2000 + Number(trimmed))
}

export interface QualificationFormValues {
  educationYears: string
  desiredOpenYear: string
  desiredOpenMonth: string
}

/** 사람이 읽을 오류 문구 목록. 비어 있으면 저장해도 된다. */
export function validateQualificationForm(form: QualificationFormValues): string[] {
  const errors: string[] = []

  if (form.desiredOpenYear !== '') {
    const year = Number(form.desiredOpenYear)
    if (!Number.isInteger(year) || year < OPEN_YEAR_MIN || year > OPEN_YEAR_MAX) {
      errors.push(`희망 개점 연도는 ${OPEN_YEAR_MIN}~${OPEN_YEAR_MAX} 사이의 네 자리로 적어 주세요`)
    }
  }
  if (form.desiredOpenMonth !== '') {
    const month = Number(form.desiredOpenMonth)
    if (!Number.isInteger(month) || month < 1 || month > 12) {
      errors.push('희망 개점 월은 1~12 사이여야 합니다')
    }
  }
  if (form.educationYears !== '') {
    const years = Number(form.educationYears)
    if (!Number.isInteger(years) || years < 0) {
      errors.push('교육 경력 연수는 0 이상의 정수여야 합니다')
    }
  }
  return errors
}
